import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalKeyboardDirective } from '../modal-keyboard/modal-keyboard.directive';

@Component({
  selector: 'lib-confirm-action-modal',
  standalone: true,
  imports: [ModalKeyboardDirective],
  template: `
    @if (isOpen) {
      <div class="confirm-action-modal__backdrop" (click)="cancel.emit()">
        <div
          class="confirm-action-modal__container"
          (click)="$event.stopPropagation()"
          [libModalKeyboard]="true"
          [libModalKeyboardCanCancel]="!isLoading"
          [libModalKeyboardCanSubmit]="!isLoading"
          (libModalKeyboardCancel)="cancel.emit()"
          (libModalKeyboardSubmit)="confirm.emit()"
        >
          <h3 class="confirm-action-modal__title">{{ title }}</h3>
          <p class="confirm-action-modal__message">{{ message }}</p>

          <div class="confirm-action-modal__actions">
            <button
              type="button"
              class="confirm-action-modal__button"
              [disabled]="isLoading"
              (click)="cancel.emit()"
            >
              {{ cancelText }}
            </button>
            <button
              type="button"
              class="confirm-action-modal__button confirm-action-modal__button--danger"
              data-modal-primary-focus="true"
              [disabled]="isLoading"
              (click)="confirm.emit()"
            >
              {{ isLoading ? loadingText : confirmText }}
            </button>
          </div>
        </div>
      </div>
    }
  `,
  styles: [`
    .confirm-action-modal__backdrop {
      position: fixed;
      inset: 0;
      background: rgba(17, 24, 39, 0.45);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      z-index: 1100;
    }

    .confirm-action-modal__container {
      width: 100%;
      max-width: 420px;
      background: #ffffff;
      border-radius: 12px;
      border: 1px solid #e5e7eb;
      padding: 16px;
      box-sizing: border-box;
      display: grid;
      gap: 10px;
    }

    .confirm-action-modal__title {
      margin: 0;
      color: #111827;
      font-size: 18px;
      font-weight: 700;
    }

    .confirm-action-modal__message {
      margin: 0;
      color: #374151;
      font-size: 14px;
      line-height: 1.4;
    }

    .confirm-action-modal__actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      margin-top: 4px;
    }

    .confirm-action-modal__button {
      height: 38px;
      border-radius: 8px;
      border: 1px solid #d1d5db;
      background: #ffffff;
      color: #111827;
      padding: 0 12px;
      cursor: pointer;
    }

    .confirm-action-modal__button--danger {
      border-color: #ef4444;
      background: #ef4444;
      color: #ffffff;
    }
    .confirm-action-modal__container :is(button, input, select, textarea):focus-visible,
    .confirm-action-modal__container :is(button, input, select, textarea):focus {
      outline: 2px solid #2563eb;
      outline-offset: 2px;
    }
    .confirm-action-modal__container :is(input, select, textarea):focus-visible,
    .confirm-action-modal__container :is(input, select, textarea):focus {
      border-color: #2563eb;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
      outline: none;
    }
  `],
})
export class ConfirmActionModalComponent {
  @Input() isOpen = false;
  @Input() title = 'Confirm action';
  @Input() message = 'Are you sure you want to continue?';
  @Input() confirmText = 'Confirm';
  @Input() cancelText = 'Cancel';
  @Input() loadingText = 'Processing...';
  @Input() isLoading = false;

  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();
}
